import React from "react";
import { DefaultModal } from "../../../../global/modals/material/DefaultModal";
import { useModalContext } from "../../../../global/modals/ModalProvider";
import { Box, BoxProps } from "@mui/material";

type ListingModalSwapLimitWrapperProps = BoxProps;

export const ListingModalSwapLimitWrapper = ({
  className,
  children,
  ...props
}: ListingModalSwapLimitWrapperProps) => {
  const { closeModal } = useModalContext();

  return (
    <DefaultModal onClose={closeModal}>
      <Box
        sx={{
          padding: "1rem",
          "@media (min-width: 1240px)": {
            maxWidth: "560px",
            padding: "1.5rem",
          },
        }}
        className={className}
        {...props}
      >
        {children}
      </Box>
    </DefaultModal>
  );
};
